// extracted by mini-css-extract-plugin
export default {"title":"PopularClinics_title__eb+AH","container":"PopularClinics_container__tU29s","timelineTitle":"PopularClinics_timelineTitle__+fEqI"};